/**
 * @generated SignedSource<<8c6e2efa44d4128e987ec38a2a827f3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WebFormQuestionType = "link" | "multiple_select" | "ranking" | "rating" | "single_select" | "written_answer" | "%future added value";
export type WebFormTemplate = "poll" | "quiz" | "survey" | "%future added value";
export type GenerateAiQuizAnswersInput = {
  additionalContext?: string | null;
  organizationId: string;
  productId?: string | null;
  questionText: string;
  questionType: WebFormQuestionType;
  webFormTemplate?: WebFormTemplate | null;
};
export type WebFormEditorAddOptionWithAIButtonMutation$variables = {
  input: GenerateAiQuizAnswersInput;
};
export type WebFormEditorAddOptionWithAIButtonMutation$data = {
  readonly response: {
    readonly data: {
      readonly answers: ReadonlyArray<string> | null;
      readonly right: ReadonlyArray<string> | null;
      readonly wrong: ReadonlyArray<string> | null;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type WebFormEditorAddOptionWithAIButtonMutation = {
  response: WebFormEditorAddOptionWithAIButtonMutation$data;
  variables: WebFormEditorAddOptionWithAIButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GenerateAiQuizAnswersResponseType",
    "kind": "LinkedField",
    "name": "generateAiQuizAnswersFromQuestion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GenerateAiQuizAnswersResponse",
        "kind": "LinkedField",
        "name": "data",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "right",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "wrong",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "answers",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WebFormEditorAddOptionWithAIButtonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WebFormEditorAddOptionWithAIButtonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5a0afff4e93ee7e617f6b160ef620fc3",
    "id": null,
    "metadata": {},
    "name": "WebFormEditorAddOptionWithAIButtonMutation",
    "operationKind": "mutation",
    "text": "mutation WebFormEditorAddOptionWithAIButtonMutation(\n  $input: GenerateAiQuizAnswersInput!\n) {\n  response: generateAiQuizAnswersFromQuestion(input: $input) {\n    data {\n      right\n      wrong\n      answers\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ab3c519ba31c99fcd16073880a903206";

export default node;
